/* src/app/components/public/home-image/home-image.component.scss */
.bottom-choices {
  padding: 25px;
  background: rgba(0, 0, 0, 0.8);
}
.bottom-choices a {
  color: #2daae1 !important;
  display: block;
  text-align: right;
  font-size: 25px;
  text-transform: uppercase;
}
.bottom-choices a:last-child {
  color: #FFFFFF !important;
}
@media screen and (min-width: 768px) {
  .bottom-choices {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 999;
    background: rgba(0, 0, 0, 0.3);
  }
}
/*# sourceMappingURL=home-image.component.css.map */
